var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVybogTalChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14977_54843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4869 21.0652C20.9353 21.0652 22.1095 19.878 22.1095 18.4135C22.1095 16.949 20.9353 15.7617 19.4869 15.7617C18.0384 15.7617 16.8643 16.949 16.8643 18.4135C16.8643 19.878 18.0384 21.0652 19.4869 21.0652Z",
    fill: "#6860EE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_14977_54843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4929 5.89599H37.2811C37.2811 5.89599 33.485 5.58353 31.5723 8.58576C30.6661 10.0088 26.1476 16.9126 22.8985 21.8657C22.5644 22.3766 22.648 23.048 23.0865 23.4702C24.1472 24.4836 24.7903 25.932 24.736 27.5365C24.64 30.2854 22.4433 32.5276 19.7247 32.6585C16.7053 32.7978 14.2122 30.3657 14.2122 27.3423C14.2122 25.8222 14.8428 24.4499 15.8534 23.4829C16.2836 23.0733 16.3462 22.4062 16.0163 21.9121L13.9491 18.8381C13.2517 17.6473 12.1659 16.7268 10.8713 16.2919C10.3159 16.1061 9.67693 15.9837 8.96282 15.9837H2.90326C2.90326 15.9837 1.2704 15.8359 2.29355 17.5502L11.9947 32.9372C13.1807 34.7402 14.989 37.5482 17.6324 38.5912C18.8393 39.0683 20.468 38.9121 21.6791 38.3463C23.9467 37.2864 25.2205 35.4285 26.1601 34.0224L43.2446 7.19232C43.2446 7.19232 43.9336 5.89599 42.4929 5.89599Z",
    fill: "#6860EE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.0393 28.8222C9.98615 29.2022 7.51807 25.7946 7.51807 25.7946C7.51807 25.7946 11.8905 32.7365 12.7132 33.9864C13.5359 35.2362 15.5822 37.7782 17.6326 38.5889C18.8395 39.0661 20.6311 38.8296 21.8422 38.2638C24.1098 37.204 25.5339 35.0631 26.1644 34.0244L34.4415 21.0105C34.4415 21.0105 32.2156 20.7571 24.9074 25.1824C19.1235 28.6871 17.8289 28.6195 15.0434 28.8264L15.0393 28.8222Z",
    fill: "#9691F3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.02505,
    cy: 22.9906,
    rx: 10.2545,
    ry: 26.7865,
    transform: "rotate(-36.1589 1.02505 22.9906)",
    fill: "url(#paint0_radial_14977_54843)",
    fillOpacity: 0.72
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_14977_54843",
    x: 1.95654,
    y: 2.88672,
    width: 41.4526,
    height: 38.9883,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.530636 0 0 0 0 0.502615 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14977_54843"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2545 0 0 0 0 0.222421 0 0 0 0 0.791833 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_14977_54843",
    result: "effect2_innerShadow_14977_54843"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_14977_54843",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.02505 22.9906) rotate(90) scale(26.7865 10.4036)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14977_54843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVybogTalChatIcon);
export default __webpack_public_path__ + "static/media/VybogTAL-Chat-Icon.dd4040c35a4199bca1efc55ec93108f1.svg";
export { ForwardRef as ReactComponent };